// src/constants/data.js

export const DATA_PANGKAT = [
  // Golongan I (Pelaksana)
  /*
  { gol: "I/a", pangkat: "Juru Muda", jabatan: "Pelaksana" },
  { gol: "I/b", pangkat: "Juru Muda Tk. I", jabatan: "Pelaksana" },
  { gol: "I/c", pangkat: "Juru", jabatan: "Pelaksana" },
  { gol: "I/d", pangkat: "Juru Tk. I", jabatan: "Pelaksana" },
  
  // Golongan II (Pelaksana)
  { gol: "II/a", pangkat: "Pengatur Muda", jabatan: "Pelaksana" },
  { gol: "II/b", pangkat: "Pengatur Muda Tk. I", jabatan: "Pelaksana" },
  { gol: "II/c", pangkat: "Pengatur", jabatan: "Pelaksana" },
  { gol: "II/d", pangkat: "Pengatur Tk. I", jabatan: "Pelaksana" },
  */
  // Golongan III (Guru Ahli Pertama & Muda)
  { gol: "III/a", pangkat: "Penata Muda", jabatan: "Guru Ahli Pertama" },
  { gol: "III/b", pangkat: "Penata Muda Tk. I", jabatan: "Guru Ahli Pertama" },
  { gol: "III/c", pangkat: "Penata", jabatan: "Guru Ahli Muda" },
  { gol: "III/d", pangkat: "Penata Tk. I", jabatan: "Guru Ahli Muda" },
  
  // Golongan IV (Guru Ahli Madya & Utama)
  { gol: "IV/a", pangkat: "Pembina", jabatan: "Guru Ahli Madya" },
  { gol: "IV/b", pangkat: "Pembina Tk. I", jabatan: "Guru Ahli Madya" },
  { gol: "IV/c", pangkat: "Pembina Utama Muda", jabatan: "Guru Ahli Madya" },
  { gol: "IV/d", pangkat: "Pembina Utama Madya", jabatan: "Guru Ahli Utama" },
  { gol: "IV/e", pangkat: "Pembina Utama", jabatan: "Guru Ahli Utama" },
];